var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 7.16345 24.8366 0 16 0C7.16345 0 0 7.16345 0 16C0 24.8366 7.16345 32 16 32C24.8366 32 32 24.8366 32 16Z",
    fill: "#5C5C5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 7.16345 24.8366 0 16 0C7.16345 0 0 7.16345 0 16C0 24.8366 7.16345 32 16 32C24.8366 32 32 24.8366 32 16Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0746 12.6852C25.9487 11.4698 25.6778 10.1263 24.6805 9.42021C23.9081 8.87267 22.8928 8.85243 21.945 8.85355C19.9415 8.85355 17.9369 8.85693 15.9334 8.85806C14.0063 8.8603 12.0793 8.86143 10.1522 8.86368C9.34719 8.86368 8.56467 8.80184 7.81701 9.15037C7.17503 9.44944 6.67246 10.0183 6.37002 10.6513C5.95066 11.5317 5.86297 12.5289 5.81237 13.5026C5.71906 15.2756 5.72917 17.0531 5.84048 18.825C5.92255 20.118 6.13055 21.547 7.13006 22.3711C8.01601 23.1008 9.26624 23.1367 10.4153 23.1379C14.0625 23.1412 17.7109 23.1446 21.3593 23.1469C21.827 23.148 22.3149 23.139 22.7917 23.0873C23.7293 22.9861 24.6231 22.7174 25.2258 22.0226C25.834 21.3221 25.9903 20.3473 26.0825 19.4243C26.3074 17.1847 26.3051 14.9237 26.0746 12.6852ZM13.8242 19.1398V12.8606L19.2613 15.9997L13.8242 19.1398Z",
    fill: "#DBDBDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.f526fcb6ed277ed4e21514f36fc83492.svg";
export { ForwardRef as ReactComponent };